export const classesColor = {
  blue: 'bg-blue-50 text-blue-700',
  green: 'bg-green-50 text-green-700',
  yellow: 'bg-yellow-50 text-yellow-700',
  red: 'bg-red-50 text-red-700',
}

export const classesTitleColor = {
  blue: 'text-blue-800',
  green: 'text-green-800',
  yellow: 'text-yellow-800',
  red: 'text-red-800',
}

export const classesSvgColor = {
  blue: 'text-blue-400',
  green: 'text-green-400',
  yellow: 'text-yellow-400',
  red: 'text-red-400',
}

export const icons = {
  blue: 'i-heroicons-information-circle',
  green: 'i-heroicons-check-circle',
  yellow: 'i-heroicons-exclamation-triangle',
  red: 'i-heroicons-x-circle',
}
